import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import {urlHttpPostTaskTeacher} from "./../../Constants/Services";
import {TeacherSchedule,ScheduleTeacherReview,ScheduleTeacherHistory,GET_WEEK_START_END,validateTokenStorage} from './../../Constants/Util';
import {
  UPLOAD_PDF
} from "../../Constants/SrcImages";
import { Row, Col,NavItem,NavLink,Nav, TabContent, TabPane, } from "reactstrap";
import StoreContext from './../../../Store/Context';
import {ModalEditSchedule,UploadFile} from './../../Constants/Modal';
import classnames from "classnames";
import moment from "moment";
import {IGrades,ISetup,IAsignature_small,IformSchedule,IDiary,ITypeAsig,IWeekStartEnd} from './../../Constants/Interfaces';
import {
  getSetup,
  getGradesAsigByTeacher,
  putAgenda,
  putFileAgenda,
  postAgenda,
  getTypeAsigment,
  putAllowFile,
  putDeleteFile,
  getDiaryByTeacherHistory,
  getDiaryByTeacherReview,
  putSendSchedule,
  putTypeAsigment,
  getTeacherById
} from "../../Constants/Services";

interface IAgendaTeacherState {
  dataFormSetup: ISetup;
  dataGrades: IGrades[];
  dataDiary: IDiary[];
  dataTypeAs: ITypeAsig[];
  dataAsignature: IAsignature_small[];
  dataFSchedule: IformSchedule; 
  dataWeekStartEnd: IWeekStartEnd[];
  activeTab:string;
  msg_error:string;
  per_changeSchedule:string;
  scheduleSelected:string;
  scheduleSelectedReview:string;
  isOpenModalEditSchedule:boolean;
  isOpenUploadFile:boolean;
  file_name_random:string;
}

class AgendaTeacher extends Component<RouteComponentProps<{}>, IAgendaTeacherState> {
  static contextType = StoreContext
  constructor(props: any) {
    super(props);
    this.state = {
      dataGrades: [],
      dataAsignature: [],
      dataDiary:[],
      dataTypeAs:[],
      dataWeekStartEnd:[],
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      dataFSchedule: {
        ar_literal:"0",
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias:"",
        gr_literal:"",
        ta_id:"",
        ta_desc:"",
        date_week_selected:"0",   
        di_date:  moment(new Date()).format("YYYY-MM-DD"),
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:""
      },
      activeTab: "1",
      msg_error:"",
      per_changeSchedule:"0",
      scheduleSelected:"0",
      scheduleSelectedReview:"0",
      isOpenModalEditSchedule:false,
      isOpenUploadFile:false,
      file_name_random:""
    };

    this.fetchGradeAsig = this.fetchGradeAsig.bind(this);
    this.setGroup = this.setGroup.bind(this);
    this.setAsign = this.setAsign.bind(this);
    this.setTypeAsign = this.setTypeAsign.bind(this);
    this.setRequireFile = this.setRequireFile.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
    this.onChangeDatePicker = this.onChangeDatePicker.bind(this);
    this.handlerSaveSchedule = this.handlerSaveSchedule.bind(this);
    this.handlerCancelSchedule = this.handlerCancelSchedule.bind(this);
    this.handlerActiveTab = this.handlerActiveTab.bind(this);
    this.fetchTypeAsig = this.fetchTypeAsig.bind(this);
    this.setTypeAsignRevisar = this.setTypeAsignRevisar.bind(this);
    this.toggleAlowFile = this.toggleAlowFile.bind(this);
    this.toggleDeleteDiary = this.toggleDeleteDiary.bind(this)
    this.fetchTeacherHistory = this.fetchTeacherHistory.bind(this);
    this.setWeekStartEnd = this.setWeekStartEnd.bind(this);
    this.setDataWeekStartEnd = this.setDataWeekStartEnd.bind(this)
    this.fetchTeacherReview = this.fetchTeacherReview.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.toggleSendSchedule = this.toggleSendSchedule.bind(this);
    this.fetchTeacherSchduleAllow = this.fetchTeacherSchduleAllow.bind(this);
    this.handleSetEditTypeAsig = this.handleSetEditTypeAsig.bind(this);
    this.setFormScheduleNull = this.setFormScheduleNull.bind(this);
    this.handlerEditScheduleModal = this.handlerEditScheduleModal.bind(this);
    this.toggleEditScheduleModal = this.toggleEditScheduleModal.bind(this);
    this.handleCloseModalFileUpload = this.handleCloseModalFileUpload.bind(this);
    this.openModalUploadFile = this.openModalUploadFile.bind(this);
    this.cancelUploadFile = this.cancelUploadFile.bind(this);
    this.setNameFile = this.setNameFile.bind(this);
    this.openModalUploadFileReview = this.openModalUploadFileReview.bind(this);
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
      msg_error:""
    });
  }

  async fetchTeacherSchduleAllow() {
    const response = await getTeacherById(this.context.per_id);
    this.setState({
      per_changeSchedule: response[0].per_changeSchedule
    });
  }
  
  
  async fetchTeacherHistory({per_id,gr_id,date_week_start,date_week_end}) {
    const response = await getDiaryByTeacherHistory({per_id,gr_id,date_week_start:moment(date_week_start).format("YYYY-MM-DD"),date_week_end:moment(date_week_end).format("YYYY-MM-DD") });
    this.setState({
      dataDiary:response
    });
  }

  async fetchTeacherReview({per_id,date_week_start,date_week_end}) {
    const response = await getDiaryByTeacherReview({per_id,date_week_start:moment(date_week_start).format("YYYY-MM-DD"),date_week_end:moment(date_week_end).format("YYYY-MM-DD")});

    this.setState({
      dataDiary:response,
      dataFSchedule: {
        ...this.state.dataFSchedule,
        ar_literal:"0",
     as_id: "",
     as_desc: "",
     gr_id: "",
     gr_desc: "",
     gr_alias:"",
     ta_id:"",
     ta_desc:"",
     di_date:  new Date().toString(),
     di_alowfile: "0",
     di_desc: "",
     di_id:"",
     di_preescolar:""
   },
   msg_error:""
    });
  }

  async fetchTypeAsig() {
    const response = await getTypeAsigment();
   
    this.setState({
      dataTypeAs:response,
      msg_error:""
    });
  }
  
  async fetchGradeAsig() {
    const response = await getGradesAsigByTeacher(this.context.per_id);
    var grade = [];
    var asignat = [];
    var hashGr = {}
    var hashAsig = {}
    grade = response.filter(o => hashGr[o.gr_id]|| o.gr_id === null ? false : hashGr[o.gr_id] = true);
    asignat = response.filter(o => hashAsig[o.as_id]|| o.as_id === null ? false : hashAsig[o.as_id] = true);
    asignat.sort(function (a, b){
      return (a.as_id - b.as_id)
    })

    grade.sort(function (a, b){
      return (a.gr_id - b.gr_id)
    })
    this.setState({
      dataAsignature:asignat,
      dataGrades:grade,
      msg_error:""
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchSetup();
    this.fetchTeacherSchduleAllow();
    this.fetchGradeAsig();
    this.fetchTypeAsig();
  }

  setWeekStartEnd(activeTab,status) {
    const props = this.state;
    var dataStartTrimestre;
    var dataEndTrimestre;

    if(props.dataFormSetup.set_trimestre==="I"){
      dataStartTrimestre= props.dataFormSetup.set_start_ft;
      dataEndTrimestre = props.dataFormSetup.set_end_ft;
    }
    else if(props.dataFormSetup.set_trimestre==="II"){
      dataStartTrimestre= props.dataFormSetup.set_start_st;
      dataEndTrimestre = props.dataFormSetup.set_end_st;
    }
    else if(props.dataFormSetup.set_trimestre==="III"){
      dataStartTrimestre= props.dataFormSetup.set_start_tt;
      dataEndTrimestre = props.dataFormSetup.set_end_tt;
    }

    var daysMonth = GET_WEEK_START_END({ startDate: dataStartTrimestre, endDate: dataEndTrimestre });
    var position=0;
    if(status){
      position = Number(props.dataFSchedule.date_week_selected)
    }
    else{
      daysMonth.map((data, i) => {
        if( moment(new Date()).isAfter(moment(data.dateStart).format("YYYY-MM-DD")) &&   moment(new Date()).isBefore(moment(data.dateEnd).add(1,'days').format("YYYY-MM-DD")))
        {
         position=i;
        }
        return null
      });
    }

    this.setState({
      dataWeekStartEnd: daysMonth,
      dataFSchedule:{
        ...this.state.dataFSchedule,
        date_week_selected: position.toString(),
      },
      msg_error:""
    });

    if(activeTab==="2")
    {
      this.fetchTeacherReview({per_id:this.context.per_id,date_week_start:daysMonth[position.toString()].dateStart,date_week_end:daysMonth[position.toString()].dateEnd})
    }
    else if(activeTab==="3"){
      if(props.dataFSchedule.gr_id.length>0){
        this.fetchTeacherHistory({per_id:this.context.per_id,gr_id:props.dataFSchedule.gr_id,date_week_start:daysMonth[position.toString()].dateStart,date_week_end:daysMonth[position.toString()].dateEnd})
      }
    }
  }
  
  handlerActiveTab(id: string) {
    if(id==="2"|| id ==="3")
    {
      setTimeout(() => {
        this.setWeekStartEnd(id,false);
      }, 500);

      
    }
    this.setState({
      activeTab: id,
      msg_error:"",
      dataDiary:[],
      dataFSchedule:{
        ...this.state.dataFSchedule,
        ar_literal:"0",
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias:"",
        ta_id:"",
        ta_desc:"", 
        di_date:  new Date().toString(),
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:""
      }
    });

  }
  
  setDataWeekStartEnd({date_week_selected}) {
    const props = this.state;

    if(Number(date_week_selected) >=0 && Number(date_week_selected) < Number(props.dataWeekStartEnd.length))
    {
      this.setState({
        dataFSchedule: {
          ...this.state.dataFSchedule,
          date_week_selected
        },
        msg_error:""
      });

      if(props.activeTab==="2"){
        this.fetchTeacherReview({per_id:this.context.per_id,date_week_start:props.dataWeekStartEnd[date_week_selected].dateStart,date_week_end:props.dataWeekStartEnd[date_week_selected].dateEnd})
      }
      else if(props.activeTab==="3"){
        this.fetchTeacherHistory({per_id:this.context.per_id,gr_id:props.dataFSchedule.gr_id,date_week_start:props.dataWeekStartEnd[date_week_selected].dateStart,date_week_end:props.dataWeekStartEnd[date_week_selected].dateEnd})
      }
    }
  }

  setGroup({gr_id,gr_desc,gr_alias,fetch,ar_literal,gr_literal}) {
    const props = this.state;
    if(fetch){
      this.fetchTeacherHistory({per_id:this.context.per_id,gr_id,date_week_start:props.dataWeekStartEnd[props.dataFSchedule.date_week_selected].dateStart,date_week_end:props.dataWeekStartEnd[props.dataFSchedule.date_week_selected].dateEnd})
    }
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        gr_id,
        gr_desc,
        gr_alias,
        ar_literal,
        gr_literal
      },
      msg_error:""
    });
  }

  setAsign({as_id,as_desc}) {
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        as_id,
        as_desc
      },
      msg_error:""
    });
  }
  
  toggleAlowFile({di_id,di_alowfile}) {
    const props = this.state.activeTab;
    const body = {
      di_alowfile,
      di_id
    };
    putAllowFile(body)
    setTimeout(() => {
    this.setWeekStartEnd(props,true);
    }, 500);
  }
  
  toggleSendSchedule() {
    const props = this.state.activeTab;
    const body = {
      per_id:this.context.per_id
    };
    putSendSchedule(body);
    setTimeout(() => {
      this.setWeekStartEnd(props,true);
    }, 500);
  }

  toggleDeleteDiary({di_id}) {
    const props = this.state.activeTab;
    const body = {
      di_id
    };
    putDeleteFile(body)
    setTimeout(() => {
      this.setWeekStartEnd(props,true);
    }, 500);
  }

  setTypeAsign({ta_id,ta_desc}) {
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        ta_id,
        ta_desc
      },
      msg_error:""
    });
  }

  setTypeAsignRevisar({di_id,ta_id,ta_desc}) {
    const body = {
      di_id,
      di_typeassignment:ta_id
    };
    putTypeAsigment(body)
    setTimeout(() => {
      this.setWeekStartEnd(this.state.activeTab,true);
    }, 500);
    this.setState({
      dataFSchedule: {
        ar_literal:"0",
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias:"",
        ta_id:"",
        ta_desc:"",
        gr_literal:"",
        date_week_selected:this.state.dataFSchedule.date_week_selected,   
        di_date:  new Date().toString(),
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:""
      },
      msg_error:"",
      scheduleSelected:"0"
    });
  }

  setFormScheduleNull(){
       this.setState({
      dataFSchedule: {
        ar_literal:"0",
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias:"",
        ta_id:"",
        ta_desc:"",
        gr_literal:"",
        date_week_selected:this.state.dataFSchedule.date_week_selected,   
        di_date:  new Date().toString(),
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:""
      },
      msg_error:"",
      scheduleSelected:"0"
    });
  }

  setRequireFile({di_alowfile}) {
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        di_alowfile
      },
      msg_error:""
    });
  }
  
  onChangeDesc(e: any) {
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  onChangeDatePicker(date: any) {
    this.setState({
      dataFSchedule: {
        ...this.state.dataFSchedule,
        di_date: moment(date).format("YYYY-MM-DD"),
      },
    });
  }

  handleSetEditTypeAsig({scheduleSelected,di_preescolar}){
    if(di_preescolar==="0"){
        this.setState({
          scheduleSelected,
          msg_error:""
        });
    }
  }

  handlerSaveSchedule() {
    const props = this.state.dataFSchedule;
    var deleteNote="0";
    if(props.ta_id ==="1" ||  props.ta_id==="2"){
      deleteNote ="1";
    }
    if(this.state.activeTab==="3"){
      let body ={};
      if(props.gr_literal==="1"){  
        body = {
          di_id:props.di_id,
          di_grade: props.gr_id,
          di_asignature: "1",
          di_date:props.di_date,
          di_typeassignment:"1",
          di_desc:props.di_desc,
          di_alowfile:props.di_alowfile,
          di_preescolar:"1",
          dNote:deleteNote
        };
    
        putAgenda(body);
        this.setState({
          dataFSchedule: {
            ...this.state.dataFSchedule,
            as_id: "",
            as_desc: "",
            ta_id:"",
            ta_desc:"",
            di_date:  new Date().toString(),
            date_week_selected:props.date_week_selected,
            di_alowfile: "0",
            di_desc: "",
            gr_literal:"",
            di_id:"",
            di_preescolar:""
          },
          isOpenModalEditSchedule:false,
          msg_error:""
        });
      }
      else{
        body = {
          di_id:props.di_id,
          di_grade: props.gr_id,
          di_asignature: props.as_id,
          di_date:props.di_date,
          di_typeassignment:props.ta_id,
          di_desc:props.di_desc,
          di_alowfile:props.di_alowfile,
          di_preescolar:"0",
          dNote:deleteNote
        };
    
        putAgenda(body);
        this.setState({
          dataFSchedule: {
            ...this.state.dataFSchedule,
            as_id: "",
            as_desc: "",
            ta_id:"",
            ta_desc:"",
            di_date:  new Date().toString(),
            date_week_selected:props.date_week_selected,
            di_alowfile: "0",
            di_desc: "",
            di_id:"",
            di_preescolar:"",
            gr_literal:""
          },
          isOpenModalEditSchedule:false,
          msg_error:""
        });
      }
    }
    else{
      let body ={};
      if(props.gr_literal==="1"){
         body = {
          di_person:this.context.per_id,
          di_grade: props.gr_id,
          di_asignature: props.as_id,
          di_date:moment(props.di_date.toString()).format("YYYY-MM-DD"),
          di_typeassignment:"1",
          di_desc:props.di_desc,
          di_alowfile:props.di_alowfile,
          di_preescolar:"1",
          file_name:this.state.file_name_random
        };
        if(props.gr_id.length>0 && props.di_desc.length>0 && props.as_id.length>0){
         postAgenda(body);
          this.setState({
            dataFSchedule: {
              ar_literal:"0",
              as_id: "",
              as_desc: "",
              gr_id: "",
              gr_desc: "",
              gr_alias:"",
              ta_id:"",
              ta_desc:"",
              gr_literal:"",
              di_date:  new Date().toString(),
              date_week_selected:props.date_week_selected,
              di_alowfile: "",
              di_desc: "",
              di_id:"",
              di_preescolar:"",
            },
            isOpenModalEditSchedule:false,
            msg_error:"",
            file_name_random:""
          });
        }
        else{
          this.setState({msg_error:"Algunos campos estan vacios"})
        }
      }
      else{
         body = {
          di_person:this.context.per_id,
          di_grade: props.gr_id,
          di_asignature: props.as_id,
          di_date:moment(props.di_date).format("YYYY-MM-DD"),
          di_typeassignment:props.ta_id,
          di_desc:props.di_desc,
          di_alowfile:props.di_alowfile,
          di_preescolar:"0",
          file_name:this.state.file_name_random
        };
        if(props.gr_id.length>0 && props.ta_id.length>0 && props.di_desc.length>0  && props.as_id.length>0){
          postAgenda(body);
          this.setState({
            dataFSchedule: {
              ar_literal:"0",
              as_id: "",
              as_desc: "",
              gr_id: "",
              gr_desc: "",
              gr_alias:"",
              ta_id:"",
              ta_desc:"",
              gr_literal:"",
              di_date:  new Date().toString(),
              date_week_selected:props.date_week_selected,
              di_alowfile: "0",
              di_desc: "",
              di_id:"",
              di_preescolar:""
            },
            file_name_random:"",
            isOpenModalEditSchedule:false,
            msg_error:""
          });
        }
        else{
          this.setState({msg_error:"Algunos campos estan vacios"})
        }
      }
    }

    if(this.state.activeTab==="3"){
      setTimeout(() => {
        this.setDataWeekStartEnd({date_week_selected:props.date_week_selected})
      }, 1000);
     
    }
  }

//TODO
  handlerCancelSchedule() {
    this.setState({
      dataFSchedule: {
        ar_literal:"0",
        as_id: "",
        as_desc: "",
        gr_id: "",
        gr_desc: "",
        gr_alias:"",
        ta_id:"",
        ta_desc:"",
        gr_literal:"",
        di_date:  new Date().toString(),
        date_week_selected:"0",
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:""
      },
      msg_error:""
  })
}

  toggleEditScheduleModal() {
    this.setState((prevState) => ({
      isOpenModalEditSchedule: !prevState.isOpenModalEditSchedule,
      dataFSchedule: {
        ...this.state.dataFSchedule,
        as_id: "",
        as_desc: "",
        ta_id:"",
        ta_desc:"",
        di_date:  new Date().toString(),
        di_alowfile: "0",
        di_desc: "",
        di_id:"",
        di_preescolar:"",
        gr_literal:""
      },
      msg_error:""
    }));
  }

  handlerEditScheduleModal(data) {
    this.setState((prevState) => ({
      isOpenModalEditSchedule: !prevState.isOpenModalEditSchedule,
      dataFSchedule: {
        ar_literal:data.ar_literal,
        as_id: data.as_id,
        as_desc: data.as_desc,
        gr_id: data.gr_id,
        gr_alias:data.gr_alias,
        gr_desc: data.gr_desc,
        ta_id:data.ta_id,
        ta_desc:data.ta_desc,
        date_week_selected:this.state.dataFSchedule.date_week_selected,   
        di_date:  data.di_date,
        di_alowfile: data.di_alowfile,
        di_desc: data.di_desc,
        di_id:data.di_id,
        di_preescolar:data.di_preescolar,
        gr_literal:data.gr_literal
      },
      msg_error:""
    }));
  }

  handleCloseModalFileUpload() {
    this.setState((prevState) => ({
      isOpenUploadFile: !prevState.isOpenUploadFile,
      // file_name_random:""
    }));
    // setTimeout(() => {
    //   this.fetchStudentProfile();
    // }, 1000);
  }

  cancelUploadFile() {
    this.setState({
      file_name_random: "",
    });
  }
  
  setNameFile({name_file}) {
    if(this.state.activeTab==="1"){
      this.setState({
        file_name_random: name_file,
      });
    }
    if(this.state.activeTab==="2"){
     const body = {
       di_id:this.state.scheduleSelectedReview,
        di_person:this.context.per_id,
        file_name:name_file
      };
      this.setState({
        file_name_random: "",
        scheduleSelectedReview:""
      });
      putFileAgenda(body)
    }

  }

  openModalUploadFile() {
    this.setState((prevState) => ({
      isOpenUploadFile: !prevState.isOpenUploadFile,
      // file_name_random: this.context.per_id+"_"+ Math.floor(Math.random() * (1000000 - 1 + 1)) + 1
    }));
  }

  openModalUploadFileReview({di_id}) {
    this.setState((prevState) => ({
      isOpenUploadFile: !prevState.isOpenUploadFile,
      scheduleSelectedReview:di_id
    }));
  }

  render() {
    const props = this.state;
       return (
      <React.Fragment>
        {props.isOpenUploadFile && (
          <UploadFile
          isOpen={props.isOpenUploadFile}
          toggle={this.handleCloseModalFileUpload}
          IMG_AVATAR={UPLOAD_PDF}
          nameImg={this.context.per_id}
          urlHttp={urlHttpPostTaskTeacher}
          setNameFile={this.setNameFile}
          />
        )}

        {props.isOpenModalEditSchedule && (
          <ModalEditSchedule
          dataTasignature={props.dataTypeAs}
          dataGroup = {props.dataGrades}
          dataAsig = {props.dataAsignature}
          dataFSchedule = {props.dataFSchedule}
          setGroup = {this.setGroup}
          setAsign = {this.setAsign}
          setTypeAsign ={this.setTypeAsign}
          setRequireFile = {this.setRequireFile}
          onChangeDesc ={this.onChangeDesc}
          onChangeDatePicker = {this.onChangeDatePicker}
          toggleSave ={this.handlerSaveSchedule}
          toggleClose ={this.toggleEditScheduleModal}
          toggle={this.handlerEditScheduleModal}
          isOpen ={props.isOpenModalEditSchedule}
          title ="Editar agenda"
          />
        )}
        <Row>
        <Col xs={12} className="text-center">
            <h5 className="font-weight-bold">Agenda</h5>
          </Col>
        </Row>
                <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === "1" })}
              onClick={() => {
                this.handlerActiveTab("1");
              }}
            >
              Crear
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === "2" })}
              onClick={() => {
                this.handlerActiveTab("2");
              }}
            >
              Revisar
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === "3" })}
              onClick={() => {
                this.handlerActiveTab("3");
              }}
            >
             Historial
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={props.activeTab} className="font-size-14">
          <TabPane tabId="1" className="scroll-none">
              <TeacherSchedule 
              dataTasignature={props.dataTypeAs}
              dataGroup = {props.dataGrades}
              dataAsig = {props.dataAsignature}
              dataFSchedule = {props.dataFSchedule}
              setGroup = {this.setGroup}
              setAsign = {this.setAsign}
              setTypeAsign ={this.setTypeAsign}
              setRequireFile = {this.setRequireFile}
              onChangeDesc ={this.onChangeDesc}
              onChangeDatePicker = {this.onChangeDatePicker}
              toggleSave ={this.handlerSaveSchedule}
              toggle={this.handlerCancelSchedule}
              msg_error ={props.msg_error}
              toggleUpload = {this.openModalUploadFile}
              toggleCancelFile ={this.cancelUploadFile}
              file_ramdon_key= {props.file_name_random}
              />
          </TabPane>
          <TabPane tabId="2">
            <ScheduleTeacherReview
            data = {props.dataDiary}
            dataTa = {props.dataTypeAs}
            dataFSchedule = {props.dataFSchedule}
            setTypeAs = {this.setTypeAsignRevisar}
            toggleDelete = {this.toggleDeleteDiary}
            toggleTypeAsig = {this.setAsign}
            handleSetEditTypeAsig = {this.handleSetEditTypeAsig}
            scheduleSelected={props.scheduleSelected}
            toggleAlowFile ={this.toggleAlowFile}
            dataWeekStartEnd = {props.dataWeekStartEnd}
            setDataWeekStartEnd={this.setDataWeekStartEnd}
            toggleSendSchedule = {this.toggleSendSchedule}
            setFormScheduleNull = {this.setFormScheduleNull}
            toggleUpload = {this.openModalUploadFileReview}
            />
          </TabPane>
          <TabPane tabId="3" id="schedule-history">
          <ScheduleTeacherHistory
          data = {props.dataDiary} 
          dataGroup ={props.dataGrades}
          dataWeekStartEnd = {props.dataWeekStartEnd}
          dataFSchedule = {props.dataFSchedule}
          setGroup={this.setGroup}
          setDataWeekStartEnd={this.setDataWeekStartEnd}
          per_changeSchedule ={props.per_changeSchedule}
          openModalEdit={this.handlerEditScheduleModal}
          />
          </TabPane>
        </TabContent>
       
      </React.Fragment>
    );
  }
}

export default AgendaTeacher;
